import React from 'react';
// import Header from '../components/Header';
// import MobileHeader from '../components/MobileHeader';
// import NewHeader from '../components/NewHeader';
import TopUtilityHeader from '../components/TopUtilityHeader';
// import NewMobileHeader from '../components/NewMobileHeader';
import Preloader from '../components/Preloader';
// import AlphaSlider from '../components/AlphaSlider';
import MainSlider from '../components/MainSlider';
// import PrinciplesModern from '../components/PrinciplesModern';
import AboutSection from '../components/AboutSection';
import ServiceQuery from '../components/ServiceQuery';
import ServiceSection from '../components/ServiceSection';
import CallToAction from '../components/CallToAction';
import TestimonialSection from '../components/TestimonialSection';
import ProjectStickyFull from '../components/ProjectStickyFull';
import BlogSection from '../components/BlogSection';
import OurBlogSection from '../components/OurBlogSection';
// import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="industify_fn_wrapper_all" data-nav-skin="transdark">
      <div className="industify_fn_wrapper">
        {/* <TopUtilityHeader /> */}
        {/* <Header /> */}
        {/* <MobileHeader /> */}
        {/* <NewHeader /> */}
        {/* <NewMobileHeader /> */}
        <Preloader />
        {/* <AlphaSlider /> */}
        <MainSlider />
        {/* <PrinciplesModern /> */}
        <AboutSection />
        <CallToAction />
        <TestimonialSection />
        <ServiceSection />
        <ServiceQuery />
        <ProjectStickyFull />
        <BlogSection />
        <OurBlogSection />
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export default Home;